import i18n from "@/language/i18n";
import OFFICIAL_HOLIDAYS_WIDGETS from "../widgets/OFFICIAL_HOLIDAYS_WIDGETS";

const OFFICIAL_HOLIDAYS_MODULE_WINDOW_IDENTIFIER = Object.freeze({
    OFFICIAL_HOLIDAYS_MODULE_WINDOW_ID: 'officialholidays',
    OFFICIAL_HOLIDAYS_CALENDARS_MODULE_WINDOW_ID: 'officialholidaycalendars',
    STATES_MODULE_WINDOW_ID: 'system/states',
});

export { OFFICIAL_HOLIDAYS_MODULE_WINDOW_IDENTIFIER };

export default {
    OFFICIAL_HOLIDAYS_GROUP_WRAPPER: {
        type: 'group',
        id: 'officialHolidays',
        label: i18n.t('ModuleRegistry.groups.officialHolidays.name'),
        children: [],
        icon: '$wCalendar',
        sidebarIcon: '$wNavOfficialHolidays'
    },
    CHILDREN: {
        OFFICIAL_HOLIDAYS_MODULE: {
            type: 'module',
            id: 'officialHolidays',
            windowIdentifierType: OFFICIAL_HOLIDAYS_MODULE_WINDOW_IDENTIFIER.OFFICIAL_HOLIDAYS_MODULE_WINDOW_ID,
            label: i18n.t('ModuleRegistry.groups.officialHolidays.officialHolidaysOverview.label'),
            navigationImg: require('@/assets/navigation/items/icon_krankmeldung.svg'),
            routerLink: '/officialholidays',
            widgets: OFFICIAL_HOLIDAYS_WIDGETS.OFFICIAL_HOLIDAYS_WIDGETS
        },
        OFFICIAL_HOLIDAYS_CALENDARS_MODULE: {
            type: 'module',
            id: 'officialHolidayCalendars',
            windowIdentifierType: OFFICIAL_HOLIDAYS_MODULE_WINDOW_IDENTIFIER.OFFICIAL_HOLIDAYS_CALENDARS_MODULE_WINDOW_ID,
            label: i18n.t('ModuleRegistry.groups.officialHolidays.officialHolidaysCalendar.label'),
            navigationImg: require('@/assets/navigation/items/icon_krankmeldung.svg'),
            routerLink: '/officialholidayscalendar',
            widgets: OFFICIAL_HOLIDAYS_WIDGETS.CALENDAR_WIDGETS
        },
        STATES_MODULE: {
            type: 'module',
            id: 'states',
            windowIdentifierType: OFFICIAL_HOLIDAYS_MODULE_WINDOW_IDENTIFIER.STATES_MODULE_WINDOW_ID,
            label: i18n.t('ModuleRegistry.groups.officialHolidays.officialHolidaysState.label'),
            navigationImg: require('@/assets/navigation/items/icon_krankmeldung.svg'),
            routerLink: '/states',
            widgets: OFFICIAL_HOLIDAYS_WIDGETS.STATES_WIDGETS
        },
    }
}
